export default __webpack_public_path__ + "8c7a0228f9ee970aeb7c4026bf408811.png";